var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_171_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 0C49.2422 0 0 49.2422 0 110C0 170.758 49.2422 220 110 220C170.758 220 220 170.758 220 110C220 49.2422 170.758 0 110 0ZM110 171.875C102.266 171.875 96.25 165.859 96.25 158.125C96.25 150.391 101.879 144.375 110 144.375C117.348 144.375 123.75 150.391 123.75 158.125C123.75 165.859 117.348 171.875 110 171.875ZM139.691 110.859L120.312 122.891V123.75C120.312 129.336 115.586 134.062 110 134.062C104.414 134.062 99.6875 129.336 99.6875 123.75V116.875C99.6875 113.438 101.406 110 104.844 107.852L129.336 93.2422C132.344 91.5234 134.062 88.5156 134.062 85.0781C134.062 79.9219 129.379 75.625 124.223 75.625H102.266C96.7227 75.625 92.8125 79.9219 92.8125 85.0781C92.8125 90.6641 88.0859 95.3906 82.5 95.3906C76.9141 95.3906 72.1875 90.6641 72.1875 85.0781C72.1875 68.3203 85.5078 55 101.879 55H123.836C141.367 55 154.688 68.3203 154.688 85.0781C154.688 95.3906 149.102 105.273 139.691 110.859Z",
    fill: "#88A8E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_171_163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.caa765ff7092812951dd0c54903ce51e.svg";
export { ForwardRef as ReactComponent };